export default {"src":"/_next/static/media/assistant-cook-with-small-grey-text-box.a9c8e1f4.svg","height":362,"width":301};